<template>
  <div class="apply-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="isBackConfirm = true" class="nav-wrap">
        <p class="title">创建注册变更窗口</p>
        <div class="nav-right" slot="right"></div>
      </yioks-page-nav>
    </div>
    <div class="content-wrap">
      <vue-scroll :ops="vuescrollOpt">
        <div class="form-wrap">
          <el-form
            ref="mainForm"
            :model="formData"
            :rules="formDataRules"
            label-width="190px"
            class="apply-form"
            size="medium"
          >
            <el-form-item label="注册窗口名称" prop="transfer_item_name">
              <el-button type="primary" size="medium" @click="handleAddSignName"
                >添加注册窗口名称</el-button
              ><span class="" style="margin-left: 10px; color: #fff">{{
                formData.transfer_item_name
              }}</span>
            </el-form-item>
            <el-form-item label="教练员注册申请窗口期" prop="coach_submit">
              <el-date-picker
                v-model="formData.coach_submit"
                type="daterange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="opsForCoachSubmit"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="转入协会审核截止日期" prop="enter_org_audit_end">
              <el-date-picker
                type="date"
                v-model="formData.enter_org_audit_end"
                :picker-options="opsForEnterOrgAudit"
                :clearable="true"
                value-format="timestamp"
                class="input-w360"
                placeholder="选择审核截止日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="转出协会审核截止日期" prop="leave_org_audit_end">
              <el-date-picker
                type="date"
                v-model="formData.leave_org_audit_end"
                :picker-options="opsForLeaveOrgAudit"
                :clearable="true"
                value-format="timestamp"
                class="input-w360"
                placeholder="选择审核截止日期"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="是否需要在职证明" class="" prop="is_need_work">
              <el-radio-group v-model="formData.is_need_work">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是(必传)</el-radio>
                <el-radio :label="2">是(非必传)</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="是否需要居住证明"
              class=""
              prop="is_need_live_proof"
            >
              <el-radio-group v-model="formData.is_need_live_proof">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是(必传)</el-radio>
                <el-radio :label="2">是(非必传)</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="是否需要变更注册协会原因"
              class=""
              prop="is_need_reason"
            >
              <el-radio-group v-model="formData.is_need_reason">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是(必传)</el-radio>
                <el-radio :label="2">是(非必传)</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="联系人"
              prop="transfer_item_linkman"
              class="test-inline"
            >
              <el-button type="primary" @click="ifContactDiaShow = true"
                >添加联系人</el-button
              >
              <span :class="['tip', testContact ? 'yes' : 'no']">{{
                testContact ? "联系人添加成功" : "联系人未添加"
              }}</span>
            </el-form-item>

            <el-form-item label="附件上传" class="white-color">
              <el-upload
                ref="uploadFile"
                :action="uploadAction"
                :file-list="formData.transfer_item_document"
                :headers="fileUpHeaders"
                :data="fileUpParam"
                :before-upload="beforeUpload"
                :on-success="uploadSuccess"
                :on-remove="fileRemove"
              >
                <el-button type="primary">点击上传</el-button>
                <div slot="tip" class style="color: #fff">
                  只能上传jpg/png/pdf/xlsx/xls/docx/doc文件，且文件大小不能超过200M
                </div>
              </el-upload>
            </el-form-item>

            <el-form-item label="说明" prop="intro">
              <el-input
                v-show="false"
                v-model="formData.content"
                class
                placeholder
              ></el-input>
              <quill-editor
                class="editor-box"
                ref="textEditor"
                v-model="formData.content"
                :options="editorOption"
              ></quill-editor>
            </el-form-item>
          </el-form>
        </div>
      </vue-scroll>
    </div>
    <div class="post-btn">
    
      <el-button v-if="isEdit" type="primary" @click="handleFormAction('isEdit')"
        >编辑</el-button>
      <el-button v-else type="primary" @click="handleFormAction('Initiated')"
        >创建</el-button>
      <el-button @click="handleFormAction('Edit')">暂时保存</el-button>
    </div>
    <yioks-tips
      :showTips="isSubmitConfirm"
      :tips="saveBtn == 'Edit' ? '确认暂时保存？' : '确认提交？'"
      :loading="submitLoading"
      @hideTips="submitConfirm"
    ></yioks-tips>
    <yioks-tips
      :showTips="isBackConfirm"
      tips="确定放弃修改并返回吗？"
      @hideTips="backComfimDialog"
    ></yioks-tips>

    <!-- 名称弹窗 -->
    <el-dialog
      title=""
      :visible.sync="isShowNameDialog"
      width="540px"
      :before-close="nameDialogClose"
    >
      <template slot="title">
        <div class="dialog-title">添加教练员注册申请名称</div>
      </template>
      <div class="dialog-content name-dia-content" style="height: 200px">
        <el-form
          :model="nameData"
          :rules="nameFormRules"
          ref="nameDialogForm"
          label-width="100px"
          size="medium"
          class="dia-form"
        >
          <el-form-item label="开启自定义" prop="ifCustom" class>
            <el-switch v-model="nameData.ifCustom" class=""></el-switch>
          </el-form-item>

          <el-form-item
            v-show="nameData.ifCustom"
            label="自定义名称"
            prop="custom"
            class
          >
            <el-input
              v-model.trim="nameData.custom"
              class=""
              :disabled="!nameData.ifCustom"
              placeholder="请填写报名名称"
              maxlength="50"
            ></el-input>
          </el-form-item>

          <div v-show="!nameData.ifCustom">
            <el-form-item label="年份" prop="year">
              <el-date-picker
                v-model="nameData.year"
                :editable="false"
                :clearable="false"
                :picker-options="yearOpt"
                value-format="yyyy"
                type="year"
                :disabled="nameData.ifCustom"
                class="w100"
                placeholder="请选择年份"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="次数" prop="times" class>
              <span class="" style="margin-right: 10px">第</span>
              <el-input-number
                v-model="nameData.times"
                controls-position="right"
                :min="1"
                :step="1"
                step-strictly
                :disabled="nameData.ifCustom"
              ></el-input-number>
              <span class="" style="margin-left: 10px">次</span>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="footer-btn" slot="footer">
        <el-button type="primary" @click="saveNameData">保存</el-button>
        <el-button type="danger" @click="isShowNameDialog = false"
          >取消</el-button
        >
      </div>
    </el-dialog>

    <!-- 添加联系人 -->
    <el-dialog
      @open="contactDiaOpen"
      :visible.sync="ifContactDiaShow"
      :close-on-click-modal="false"
      top="13vh"
      width="850px"
      class="yi-dialog-root scroll-dialog"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title">添加联系人</span>
      </div>
      <div class="contact-dia-content">
        <vue-scroll :ops="disScrollOpt">
          <div class="dia-scroll-content">
            <el-form
              :model="contactData"
              ref="contactDialogForm"
              label-width="60px"
              size="medium"
              class="dia-form"
            >
              <div
                class="form-oneline-wrap"
                v-for="(contact, index) in contactData.contactInfoList"
                :key="contact.id"
              >
                <el-form-item
                  label="姓名"
                  :prop="'contactInfoList.' + index + '.name'"
                  :rules="{
                    required: true,
                    message: `不能为空`,
                    trigger: `blur`,
                  }"
                  class="dia-input-wrap contact-name-wrap"
                >
                  <el-input
                    placeholder="请输入联系人姓名"
                    v-model="contact.name"
                    class="dia-input-w160"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="电话"
                  :prop="'contactInfoList.' + index + '.mobile_phone'"
                  :rules="{
                    required: true,
                    validator: (rule, value, callback) => {
                      validatePhone(rule, value, callback);
                    },
                    trigger: `blur`,
                  }"
                  class="dia-input-wrap contact-phone-wrap"
                >
                  <el-input
                    placeholder="请输入联系人手机号"
                    v-model="contact.mobile_phone"
                    class="dia-input-w160"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="邮箱"
                  :prop="'contactInfoList.' + index + '.email'"
                  :rules="{
                    required: false,
                    validator: (rule, value, callback) => {
                      validateEmail(rule, value, callback);
                    },
                    trigger: `blur`,
                  }"
                  class="dia-input-wrap contact-email-wrap"
                >
                  <el-input
                    placeholder="请输入联系人邮箱"
                    v-model="contact.email"
                    class="dia-input-w160"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="单位"
                  :prop="'contactInfoList.' + index + '.work'"
                  :rules="{}"
                  class="dia-input-wrap contact-email-wrap"
                >
                  <el-input
                    placeholder="请输入联系人邮箱"
                    v-model="contact.work"
                    class="dia-input-w160"
                  ></el-input>
                </el-form-item>
                <el-button
                  class="form-oneline-btn"
                  size="small"
                  type="danger"
                  v-if="index > 0"
                  @click="delContact(index)"
                  >删除</el-button
                >
                <el-button
                  v-else
                  class="form-oneline-btn"
                  size="small"
                  type="primary"
                  @click="addContact"
                  >添加</el-button
                >
              </div>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="footer-btn" slot="footer">
        <div class="btns">
          <el-button type="primary" @click="saveContactList">保存</el-button>
          <el-button type="danger" @click="ifContactDiaShow = false"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import createScrollOpt from "@/assets/js/vuescrollOption";
import { editConfig } from "@/assets/js/pluginsConfig";
import alterFormMixins from "@/views/system_manager/orgAlteration/alterFormMixins";
import linkman from "@/views/system_manager/orgAlteration/linkman";
import uploadMixin from "@/minix/uploadMixin";
import {
  postTransferItem,
  getTransferItemDetails,
  putTransferItem,
} from "@/api/system_manager/api";

export default {
  mixins: [alterFormMixins, linkman, uploadMixin],
  components: {
    "yioks-tips": () => import("@/components/Tips/Dialog"),
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
  },

  data() {
    return {
      editorOption: editConfig(),
      vuescrollOpt: createScrollOpt(),
      disScrollOpt: createScrollOpt(true),

      isBackConfirm: false,
      submitLoading: false,
      isSubmitConfirm: false,

      formData: {
        transfer_item_name: "",
        coach_submit: "",
        coach_submit_start: "",
        coach_submit_end: "",
        leave_org_audit_end: "",
        enter_org_audit_end: "",
        is_need_work: 0, // 工作证明
        is_need_live_proof: 0, // 居住证明
        is_need_reason: 0, // 变更原因
        content: null,
        transfer_item_status: "", //  enmu('Edit', 'Initiated')
        transfer_item_linkman: [], // 联系人
        transfer_item_document: [],
      },
      isShowNameDialog: false,

      nameData: {
        year: "",
        times: "",
        custom: "",
        ifCustom: false,
      },
      saveBtn: '',
    };
  },

  computed: {
    isEdit() {
      const { isEdit } = this.$route.query;
      return isEdit && isEdit == 1 ? true : false;
    },
    transfer_item_uuid() {
      const { transfer_item_uuid } = this.$route.query;
      return transfer_item_uuid;
    },
    backUrl() {
      const { backUrl } = this.$route.query;
      return backUrl;
    }
  },

  created() {
    if(this.isEdit) this.setFormDataForEdit();
  },

  methods: {
    // 取消
    backComfimDialog(ok, status) {
      if(status) {
        if(this.backUrl) {
          this.$router.push({
            path: backUrl
          })
        } else {
          this.$router.back()
        }
      } else {
        this.isBackConfirm = false;
      }
      
      
    },

    // 确认
    submitConfirm(ok, status) {
      if (status) {
        this.handleSubmit();
      } else {
        this.isSubmitConfirm = false;
      }
    },

    // 添加名称
    handleAddSignName() {
      this.isShowNameDialog = true;
    },

    // 弹窗关闭函数
    nameDialogClose() {
      this.isShowNameDialog = false;
    },

    // 设置名字
    saveNameData() {
      this.$refs["nameDialogForm"].validate((valid) => {
        if (valid) {
          const { year, times, custom, ifCustom } = this.nameData;
          if (ifCustom) {
            this.formData.transfer_item_name = custom;
          } else {
            const { enroll_type, class_level } = this.formData;
            this.formData.transfer_item_name = `${year}年第${times}次教练员注册变更通知`;
          }
          this.isShowNameDialog = false;
          this.$refs["mainForm"].validateField("transfer_item_name");
        } else {
          return false;
        }
      });
    },

    // 表单处理
    handleFormAction(status) {
      if(status === 'Initiated' || status === 'Edit') {
        this.$set(this.formData, "transfer_item_status", status);
      }
      if(status === 'isEdit' && this.formData.transfer_item_status ==='Edit') {
        this.$set(this.formData, "transfer_item_status", "Initiated");
      }
      this.saveBtn = status;
      if (status === "Initiated") {
        this.$refs["mainForm"].validate((valid) => {
          if (valid) {
            if (this.testContact) {
              this.isSubmitConfirm = true;
            }
          }
        });
      } else {
        this.isSubmitConfirm = true;
        // this.handleSubmit();
      }
    },

    // 提交表单
    handleSubmit() {
      const {
        coach_submit,
        transfer_item_linkman,
        transfer_item_document,
        ...rest
      } = this.formData;
      let postData = {
        ...rest,
        transfer_item_linkman: JSON.stringify(transfer_item_linkman),
      };
      if (coach_submit) {
        const [coach_submit_start, coach_submit_end] = coach_submit;
        postData["coach_submit_start"] = coach_submit_start;
        postData["coach_submit_end"] = coach_submit_end;
      }
      let docList = [];
      if (transfer_item_document.length) {
        transfer_item_document.forEach((item) => {
          docList.push({
            document_url: item.url,
            document_name: item.name,
            document_id: item.document_id || "",
          });
        });
      }
      postData['transfer_item_document'] = JSON.stringify(docList);
      let requestName = this.isEdit ? putTransferItem : postTransferItem
      requestName(postData)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          this.isSubmitConfirm = false;
          this.$router.push({
            path: "org_alter_list",
          });
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    uploadSuccess(res) {
      if (Number(res.status) === 0) {
        this.formData.transfer_item_document.push({
          url: res.result.document_url,
          name: res.result.document_name,
        });
      } else {
        this.$nextTick(() => {});
        this.$message.error(res.msg);
      }
    },

    fileRemove(file, fileList) {
      this.formData.transfer_item_document = fileList;
    },

    beforeUpload(file) {
      if (file.size > 200 * 1024 * 1024) {
        this.$message.error("文件大小不能超过200M!");
        return false;
      }
      if (!/^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i.test(file.name)) {
        this.$message.error("请上传 jpg png pdf xlsx xls docx doc格式的文件!");
        return false;
      }
      let param = {
        document: file,
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.fileUpParam, key, param[key]);
        }
      }
    },

    // 编辑模式： 填充信息
    setFormDataForEdit() {
      const paramsData = {
        transfer_item_uuid: this.transfer_item_uuid,
      };
      getTransferItemDetails(paramsData)
        .then(({ data }) => {
          // 基础信息
          const { transferDocument, transferItem, transferLinkMan } =
            data.result;
            // transfer_item_status
          const {
            coach_submit_start,
            coach_submit_end,
            ...rest
          } = transferItem;
          this.formData = Object.assign({}, this.formData, rest);
          if (coach_submit_start && coach_submit_end)
            this.$set(this.formData, "coach_submit", [
              coach_submit_start,
              coach_submit_end,
            ]);

          // 联系人
          if (transferLinkMan.length) {
            this.contactData.contactInfoList = transferLinkMan;
            this.formData.transfer_item_linkman = JSON.parse(
              JSON.stringify(this.contactData.contactInfoList)
            );
            this.testContact = true;
          } else {
            this.getClassLinks();
          }

          // 文件列表
          if (transferDocument.length) {
            // transfer_item_document
            let docList = [];
            transferDocument.forEach((item) => {
              docList.push({
                url: item.document_address,
                name: item.document_title,
                document_id: item.document_id || "",
              });
            });
            this.formData.transfer_item_document = docList;
          }
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/commnApply'
@import '~@/assets/css/linDialog'
.form-wrap
  margin 0 30px
.footer-btn
  width 35%
  margin 0 auto
  display flex
  justify-content space-around
.dialog-content
  height 500px
.contact-dia-content
  height 500px
  .dia-scroll-content
    width 100%
    margin 0 20px 0 0
    .form-oneline-wrap
      display flex
      flex 1
      .form-oneline-btn
        flex-basis auto
        width 70px
        margin 0 0 20px 10px
.dia-input-w160
  width 105px !important
.tip
  margin-left 10px
  &.yes
    color $color_suc
  &.no
    color $color_unusual
.input-w360
  width 350px !important
</style>

<style lang="stylus">
@import '~@/assets/css/variable'
.apply-form
  padding-top 8px
  .el-form-item
    .editor-box
      background-color #fff
      color #333
      line-height 1
      word-break break-all
      word-wrap break-word
      .ql-toolbar.ql-snow .ql-formats
        margin-right 10px
      .ql-container
        min-height 150px
  .el-form-item__label
    color $color_white
    font-size 16px
  .el-input__inner, .el-textarea__inner
    // border-radius 0
  .el-input.is-disabled .el-input__icon
    color #666
  .el-form-item.is-required .el-form-item__label:before
    color inherit
  .el-input.is-disabled .el-input__inner
    input-disabled()
    &::-webkit-input-placeholder, &:-moz-placeholder, &::-moz-placeholder, &:-ms-input-placeholder
      color #333333
  .el-radio__label
    color $color_white
  .is-checked .el-radio__label
    color $color_suc
.white-color
  .el-upload-list__item-name
    color #fff
</style>
